<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step4_terrace.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step4_terrace.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">

          <div class="form-group">
            <div class="form-label-container">
              <label for="module" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.label') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-supporting-elements-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-supporting-elements.png'" />
            </div>
            <select id="module" required class="form-control" v-model="form.supporting_elements">
              <option value=""></option>
              <option value="concrete" v-if="datas.step3.photovoltaic_process !== 'light_reflection'">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.concrete') }}</option>
              <option value="tan_dtu">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_dtu') }}</option>
              <option value="tan_dtu_perforated_soul">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_dtu_perforated_soul') }}</option>
              <option value="tan_dtu_perforated_plage">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_dtu_perforated_plage') }}</option>
              <option value="tan_dtu_perforated_total">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_dtu_perforated_total') }}</option>
              <option value="tan_wide_range">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_wide_range') }}</option>
              <option value="tan_wide_range_soul">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.tan_wide_range_soul') }}</option>
              <option value="wood">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.wood') }}</option>
              <option value="clt">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.clt') }}</option>
              <option value="other">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.other') }}</option>
            </select>
          </div>

          <div class="form-group" v-if="form.supporting_elements === 'other'">
            <input type="text" id="supporting_elements_other" :placeholder="Translator('soprasolar.project.step4_terrace.form.supporting_elements_other')" class="form-control" v-model="form.supporting_elements_other" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.project_type.label') }}
              </label>
            </div>
            <div class="radios">
              <div class="radio" v-if="datas.step3.photovoltaic_process !== 'light_reflection'">
                <input class="radio-input" required type="radio" id="project_type_new" name="project_type" v-model="form.project_type" value="new">
                <label class="radio-label" for="project_type_new">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.project_type.new') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="project_type_repair_and_keep" name="project_type" v-model="form.project_type" value="repair_and_keep">
                <label class="radio-label" for="project_type_repair_and_keep">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.project_type.repair_and_keep') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="project_type_repair_and_clean" name="project_type" v-model="form.project_type" value="repair_and_clean">
                <label class="radio-label" for="project_type_repair_and_clean">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.project_type.repair_and_clean') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.configuration.label') }}
              </label>
            </div>
            <div class="radios">
              <div class="radio">
                <input class="radio-input" required type="radio" id="configuration_open" name="configuration" v-model="form.configuration" value="open">
                <label class="radio-label" for="configuration_open">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.configuration.open') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="configuration_close" name="configuration" v-model="form.configuration" value="close">
                <label class="radio-label" for="configuration_close">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.configuration.close') }}</p>
                </label>
              </div>
            </div>
            <p class="help-text">{{ Translator('soprasolar.project.step4_terrace.form.configuration.help') }}</p>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.slop_orientation.label') }}
              </label>
            </div>
            <div class="radios">
              <div class="radio">
                <input class="radio-input" required type="radio" id="slop_orientation_plane" name="slop_orientation" v-model="form.slop_orientation" value="plane">
                <label class="radio-label" for="slop_orientation_plane">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.slop_orientation.plane') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="slop_orientation_curve" name="slop_orientation" v-model="form.slop_orientation" value="curve">
                <label class="radio-label" for="slop_orientation_curve">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.slop_orientation.curve') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.hygrometry.label') }}
              </label>
            </div>
            <div class="radios">
              <div class="radio">
                <input class="radio-input" required type="radio" id="hygrometry_normal" name="hygrometry" v-model="form.hygrometry" value="normal">
                <label class="radio-label" for="hygrometry_normal">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.hygrometry.normal') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="hygrometry_strong" name="hygrometry" v-model="form.hygrometry" value="strong">
                <label class="radio-label" for="hygrometry_strong">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.hygrometry.strong') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="hygrometry_very_strong" name="hygrometry" v-model="form.hygrometry" value="very_strong">
                <label class="radio-label" for="hygrometry_very_strong">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.hygrometry.very_strong') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="hygrometry_dontknow" name="hygrometry" v-model="form.hygrometry" value="dontknow">
                <label class="radio-label" for="hygrometry_dontknow">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step4_terrace.form.hygrometry.dontknow') }}</p>
                </label>
              </div>
            </div>
          </div>


          <div class="form-group">
            <div class="form-label-container">
              <label for="roof_pitch" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.roof_pitch') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-terrasse-roof-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-terrasse-roof.png'" />
            </div>
            <input type="text" id="roof_pitch" class="form-control" v-model="form.roof_pitch" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="roof_length" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.roof_length') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-terrasse-roof-top-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-terrasse-roof-top.png'" />
            </div>
            <input type="text" id="roof_length" class="form-control" v-model="form.roof_length" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="roof_width" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.roof_width') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-terrasse-roof-top-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-terrasse-roof-top.png'" />
            </div>
            <input type="text" id="roof_width" class="form-control" v-model="form.roof_width" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="parapet_height" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.parapet_height') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-terrasse-roof-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-terrasse-roof.png'" />
            </div>
            <input type="text" id="parapet_height" class="form-control" v-model="form.parapet_height" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="maximum_height" class="control-label required">
                {{ Translator('soprasolar.project.step4_terrace.form.maximum_height') }}
              </label>
              <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-terrasse-roof-en.png'" />
              <help v-else :image="'/assets/soprasolar/images/project/help-terrasse-roof.png'" />
            </div>
            <input type="text" id="maximum_height" class="form-control" v-model="form.maximum_height" required>
          </div>

        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.project-wrapper {
  @include vertical-spacing-inner-top;
}
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';
import Save from '@/soprasolar-project/components/Save';
import Help from '@/soprasolar-project/components/Help';

export default {
  name: 'step-4-terrace',
  components: {
    Save,
    Help
  },
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {},
      locale: window.Translator.locale,
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step4) this.form = this.datas.step4;
  },
  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        AppControlService.update('step4', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step4) this.form = this.datas.step4;
    }
  }
};
</script>